export enum DOMAIN_TYPE {
    WorkloadDomain = "WORKLOAD",
    ManagementDomain = "MANAGEMENT"
}

export enum ARCHITECTURE {
    Standard = "STANDARD",
    Consolidated = "CONSOLIDATED"
}

export enum WORKLOAD_DOMAIN_TYPE {
    Standard = "STANDARD",
    Isolated = "ISOLATED",
    None = "NONE"
}

export enum DEPLOYMENT {
    Greenfield = "GREENFIELD",
    Brownfield = "BROWNFIELD"
}

export enum STORAGE_TYPE {
    VSAN = "vSAN",
    External_Storage = "External Storage"
}

export enum CONFIGURATION_STRATEGIES {
    workloadDeploymentOption = "workloadDeploymentOption",
    hftRaids = "hftRaids",
    ioProfile = "ioProfile",
    storageEfficiencyMetrics = "storageEfficiencyMetrics",
    profileMode = "profileMode"
}

export enum HARDWARE_PREFERENCE {
    HardwareFirst = "HARDWARE_FIRST",
    NoPreference = "NO_PREFERENCE"
}
